<template>
  <div class="home_container">
    <div :class="isMobileS?'banner':'pc-banner'">
      <img :src="isMobileS?banner:pcBanner" alt=""/>
    </div>
    <div class="content">
      <Notice :isMobileS="isMobileS" v-if="isShow"  @goClick="goClick" />
      <AddForm :isMobileS="isMobileS" v-else-if="!isShow" @onCancel="onCancel"/>
    </div>

  </div>
</template>

<script>
import banner from '@/assets/images/banner.png'
import pcBanner from '@/assets/images/pc-banner.png'
import icon from '@/assets/images/icon.png'
import notice from '@/assets/images/notice.png'
import Notice from '@/components/mounted/Notice.vue'
import AddForm from '@/components/mounted/AddForm.vue'
import isMobile from 'ismobilejs'
import wxShare from '@/utils/wxshare'
export default {
  name: 'index',
  data () {
    return {
      data: { },
      banner,
      icon,
      pcBanner,
      notice,
      isShow: true,
      isMobileS: isMobile(window.navigator.userAgent).any
    }
  },
  components: {
    Notice,
    AddForm
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      console.log('dddddddddd')
      wxShare({
        title: '云顶长白雪域秘境摄影作品大赛',
        desc: '发现身边美 邂逅长白山',
        imgUrl: 'https://cdn2-app.people.cn/static/shareLogo.png'
      }, this)
      document.title = '云顶长白雪域秘境摄影作品大赛'
    })
  },
  updated () {
    // console.log('dddddddddd')
    // wxShare({
    //   title: '云顶长白雪域秘境摄影作品征集',
    //   desc: '发现身边美 邂逅长白山',
    //   imgUrl: 'https://cdn2-app.people.cn/static/shareLogo.png'
    // }, this)
    // document.title = '云顶长白雪域秘境摄影作品征集'
    window.addEventListener('resize', function () {
      this.isMobileS = isMobile(window.navigator.userAgent).any
      console.log(this.isMobileS, 'this.isMobileS')
    })
  },
  methods: {
    onCancel (data) {
      console.log(data, 'data')
      this.isShow = data
      console.log(this.isShow, 'isShow')
    },
    goClick (istrue) {
      this.isShow = istrue
    }
  }
}
</script>

<style scoped lang="less">
.show{
  display: block;
}
.hide{
  display: none;
}
.home_container {
  background: #E9F5FF;
  height: 100vh;
}
.banner {
  height: 211px;
  overflow: hidden;
  img{
    width: 100%;
    height: 100%;
  }
}
.pc-banner{
  // max-height:466px;
}
.content{
  padding:15px;
}
</style>
